<template>
  <div class="search-container">
    <label
      id="searchs"
      ref="search"
      :for="this.labelKey"
      >
      <!-- <span
        style="
          color: red;
          font-weight: 500;
          color: #cf1322;
        "
        >* </span -->
      <!-- > -->
      End Location  </label
    >
    
    <el-autocomplete
      ref="searchAutocomplete"
      class="search-autocomplete connected"
      :id="this.labelKey"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="true"
      :popper-append-to-body="false"
      :hide-loading="true"
      @select="handleSelect"
      @blur="handleBlur($event)"
      @focus="handFocus($event)"
      @input="watchData($event)"
      v-bind="$attrs"
      v-on="$listeners"
      popper-class="search-autocomplete-popper"
    >
       <template  slot-scope="{ item }"> 
        <!-- searchLoading -->
        <div v-show="searchLoading === false">
          <div v-if="item.address == 'No Matches'" class="search-disbled">
            <button :disabled='true'>No Matches</button>
          </div>
          <div v-else class="search-result-wrapper">
            <div class="search-result-container">
              <span
                v-if="item.pointType=== 'address' && item.address !== 'No Matches'"
                class="address-icon search-result-icon"
              ></span>
              <svg-icon v-else-if="item.address !== 'No Matches'" :name="getIconUrl(item)" class="poi-icon" />
              <div class="search-result-content">
                <p
                  v-if="item.isHistory || item.pointType === 'poi'"
                  class="title overflow-management"
                >
                  {{ item.unifiedTitle }}
                </p>
                <p
                  v-else
                  v-html="item.unifiedTitle"
                  class="title overflow-management"
                ></p>
                <p class="address overflow-management" aria-disabled="true">
                  {{ item.address }}
                </p>
              </div>
            </div>
          </div>
        </div>
    </template>
     
    </el-autocomplete>
    <div class="search-loading" v-if="searchLoading">
      <div class="loading"></div>
      <span>Searching...</span>
    </div>
    <span class="places" v-if="isShowClearIcon"><svg-icon  name="icon-16-place (1)" ></svg-icon></span>
    <span class="places clearIcon" v-else @mousedown="clearSearchLocation"><svg-icon  name="input-close" ></svg-icon></span>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import { getSearchTimeZone } from "@/api/common";
import { iconInDifferentPoint } from "@/config/map-icons";
import { getAddressDetail, getPoiDetail } from "@/api/search.js";
export default {
  props: ["token","currentValue","SoptIndex","labelKey",'type'],
  data() {
    return {
      pickupAddress: "",
      currentInfo: null,
      list: [],
      searchLoading: false,
      isShowClearIcon: true,
    };
  },
  watch: {
    // searchLoading: {
    //   handler(value) {
    //     let dom = document.querySelector('.search-autocomplete-popper')
    //     if(value) {
    //       dom.style = 'display: none'
    //     }else {
    //       dom.style = 'display: black'
    //     }
    //   }
     
    // },
    currentValue:{
      handler(value) {
        try {
          if (!value) {
            this.$nextTick(() => {
              this.$refs["search"].classList.add("search-blur");
              this.$refs["search"].classList.remove("search-focus");
            })
          } else {
            this.$nextTick(() => {
              this.$refs["search"].classList.remove("search-blur");
              this.$refs["search"].classList.add("search-value-focus");
            })
          }
        } catch (error) {
          console.log(error);
        }
        
      },
      immediate: true,
      deep: true
    },
    currentInfo: {
      handler(value) {
        try {
        let dom = this.$refs["search"].nextElementSibling.nextElementSibling.children[0].children[0];
        
          dom.addEventListener('blur',() => {
            if(value) {
              this.$refs["search"].classList.add("search-value-focus");
            }
          })
          if(value) {
            if(value.value !== dom.value) {
              dom.value = value.value
              this.$refs["search"].classList.add("search-value-focus");
            }else if(value === this.currentInfo.value) {
              dom.value = value.value
            }
          }
        } catch  {
          return
        }
      },
      deep: true
    }
  },
  created() {},
  methods: {
    ...mapActions({
      getAddressSearchAsync: "search/getAddressSearch",
      // updateDispatchSearchValueAsync: "search/updateDispatchSearchValue",
      // setSearchResultAsync: "search/setSearchResult",
      // refreshData: "dispatch/refreshData",
    }),

    handFocus() {
      this.isShowClearIcon = false
      this.activeDom()
    },
    handleBlur(el) {
      console.log(el.target.value,'169');
      let dom = el.target
      let value = dom.value
      this.isShowClearIcon = true
        if(value === '' || value === null || value === undefined) {
          this.$nextTick(() => {
            dom.value = ''
            this.currentInfo = ''
            this.$emit('clear')
            this.$refs["search"].classList.add("search-blur");
          })
        }
        else if(value && (this.currentInfo == null || this.currentInfo == undefined || this.currentInfo == '') && this.type !== 'edit') {
          dom.value = ''
          this.$emit('clear')
          this.$refs["search"].classList.add("search-blur");
        }
        if(this.currentInfo) {
          if(value !== this.currentInfo.value) {
            dom.value = this.currentInfo.value
            this.$refs["search"].classList.add("search-value-focus");
          }else if(value === this.currentInfo.value) {
            dom.value = this.currentInfo.value
          }
        }
      if (el.target.value) {
        this.focusDom()
        this.$emit('isHasSearchInfo', {data: this.list[0]?.address === 'No Matches' ? true : false, token: this.token})
      } else {
        this.blurDom()
      }
    },
    clearSearchLocation() {
      this.$refs['searchAutocomplete'].$el.children[0].children[0].value = ''
      this.$emit('clear', {token: this.token, StopIndex: this.SoptIndex, clear: true})
    },
    watchData(el) {
      if (el) {
        this.focusDom()
      } else {
        this.blurDom()
      }
    },
    blurDom() {
        this.$refs["search"].classList.add("search-blur");
        this.$refs["search"].classList.remove("search-focus");
        this.$refs["search"].nextElementSibling.classList.remove("is-focus");
    },
    focusDom() {
        this.$refs["search"].classList.remove("search-blur");
        this.$refs["search"].classList.add("search-value-focus");
        this.$refs["search"].nextElementSibling.classList.remove("is-focus");
        // 
    },
    activeDom() {
        this.$refs["search"].classList.remove("search-blur");
        this.$refs["search"].classList.remove("search-value-focus");
        this.$refs["search"].classList.add("search-focus");
        this.$refs["search"].nextElementSibling.classList.add("is-focus");
    },
    // 失去焦点时更新数据
    handleSearch() {
      this.searchValue = this.pickupAddress;
      this.$refs.searchAutocomplete.focus();
    },
    getIconUrl(point) {
      point.pointType = 'address'
      return iconInDifferentPoint(point).listIcon;
    },
    querySearch(queryString, cb) {
      this.searchLoading = true
      this.getAddressSearchAsync({
        value: queryString,
        searchValue: this.searchValue,
        isShowHistoricalData: true,
      }).then((res) => {
         this.searchLoading = false
        this.searchValue = "";
        // 有历史记录时展示清除按钮
        // if (!queryString && res.length) {
        //   res.unshift({ showClearHistory: true, value: "Noda" });
        // }

        if(res.length === 0) {
          res = [{ address: 'No Matches', value: "No Matches" }]
          this.list = res
        }
        // res = res.filter(item => !item.isFacility)
        this.list = res
        cb(res);
        
      });
    },
    handleSelect(item) {
      let info = Object.assign({}, item, {
        unifiedTitle: item.value,
        isMapChange: true,
      });
      this.updateSearchInfo(info);
    },
    clearHistory() {
      localStorage.removeItem("addressSearchList");
      this.$refs.searchAutocomplete.close();
      this.$refs.searchAutocomplete.suggestions = [];
    },
    handleEmpty() {
      this.CurrentIndex = this.pickupAddress = undefined;
      this.$refs.searchAutocomplete.close();
      this.$refs.searchAutocomplete.suggestions = [];
    },
    updateSearchInfo(info) {
      this.currentInfo = info
      this.$nextTick(() => {
        let dom = this.$refs["search"].nextElementSibling.children[0].children[0]
        dom.value = info.value
      })
      
      
      // let currentValue = this.pickupAddress;
      // this.updateDispatchSearchValueAsync(currentValue);
      // this.setSearchResultAsync({ result: info, source: "dispatch" });
      let timeZone = new Promise((resolve) => {
        getSearchTimeZone(info.latitude, info.longitude).then((res) => {
          var result = { }
          // if (res.AdminInfo.TimeZone.inDaylightTime) {
          //   result.timeZone = res.AdminInfo.TimeZone.nameDstShort;
          //   result.data = res
          // } else {
          //   result.timeZone = res.AdminInfo.TimeZone.nameShort ;
          //   result.data = res
          // }
          // result.timeZone = res.AdminInfo.TimeZone.nameShort;
          result.data = res
          resolve(result);
        });
      });
      let { ident, context, id } = info;
      if (ident) {
        var getPoi = new Promise((resolve) => {
          getPoiDetail(ident).then((result) => {
            let data = result.res.data;
            resolve(data);
          });
        });
      } else {
        var getCity = new Promise((resolve) => {
          getAddressDetail({ context: context, id: id }).then((res) => {
            resolve(res.res.data.location.address);
          });
        });
      }

      Promise.all([timeZone, getPoi, getCity]).then((res) => {
        let cityInfo = {};
        let showaddress = ''
        let appaddress = ''
        if (res[2] === undefined) {
          cityInfo = {
            city: res[1].city || "",
            state: res[1].state || "",
            postalCode: res[1].zip || "",
            country: res[1].country || "",
          };
          
        } else {
          cityInfo = {
            city: res[2].city || "",
            state: res[2].stateCode || "",
            postalCode: res[2].postalCode || "",
            country: res[2].countryCode || "",
          };
          // if(info.value === res[2].city || res[2].city === undefined) {
          //   appaddress = `${info.value + ', '}${res[0].data.Address.State}`
          //   showaddress = info.value
          // }else {
          //   appaddress = `${info.value + ', '}${res[2]?.city + ', '}${res[0].data.Address.State}`
          //   showaddress = info.value
          // }
        }
        //address action
        let dataInfo = {
          cityData: Object.assign(
            {},
            cityInfo,
            { 
              // timeZone: res[0].timeZone,
              latitude: info.latitude,
              longitude: info.longitude,
              address: info.ident ? `${info.address.slice(0,info.address.indexOf(','))}, ${res[1].city}, ${res[1].state}` :  appaddress,
              showaddress: info.ident ? `${info.address.slice(0,info.address.indexOf(','))}, ${res[1].city}, ${res[1].state}` :  showaddress,
              // Tz: res[0].data.AdminInfo.TimeZone.id,
              // offset: res[0].data.AdminInfo.TimeZone.offset
            },
            { souch: info }

          ),
          token: this.token,
          StopIndex: this.SoptIndex
        };
        try {
          console.log(dataInfo)
          this.$emit("getLoaction", dataInfo);
        } catch (error) {
          console.log(error);
        }
      });
    },
  },
  mounted() {
    // try {
    //   let dom = this.$refs["search"].nextElementSibling.nextElementSibling.children[0].children[0];
    //   dom.addEventListener('blur',(event) => {
    //     let value = event.target.value
    //     let dom = this.$refs["search"].nextElementSibling.nextElementSibling.children[0].children[0];
    //     if(value === '' || value === null || value === undefined) {
    //       this.$nextTick(() => {
    //         dom.value = ''
    //         this.currentInfo = ''
    //         this.$emit('clear', {token: this.token, StopIndex: this.SoptIndex})
    //         this.$refs["search"].classList.add("search-blur");
    //       })
    //     }
    //     else if(value && (this.currentInfo == null || this.currentInfo == undefined || this.currentInfo == '') && this.type !== 'edit') {
    //       dom.value = ''
    //       this.$refs["search"].classList.add("search-blur");
    //     }
    //     if(this.currentInfo) {
    //       if(value !== this.currentInfo.value) {
    //         dom.value = this.currentInfo.value
    //         this.$refs["search"].classList.add("search-value-focus");
    //       }else if(value === this.currentInfo.value) {
    //         dom.value = this.currentInfo.value
    //       }
    //     }
    //   })
    // } catch {
    //   return
    // }
  }
};
</script>

<style lang="scss" scoped>
.search-loading {
  display: flex;
  height: 52px;
  width: 100%;
  align-items: center;
  border-radius: 6px;
  position: absolute;
  z-index: 99999;
  padding-left: 18px;
  box-shadow: 0 1px 5px 0 rgba(0, 5, 57, 0.2);
  border: solid 1px #e1e3e9;
  background: #fff;
  .loading {
    width: 16px;
    height: 16px;
    line-height: 16px;
    margin-right: 8px;
    animation: Rotation .5s linear infinite;
    background-image: url('~@/views/dispatchs/image/Loading-Blue.svg');
    // background-image: url('../../../image/Loading-Blue.svg');
    @keyframes identifier {
      0% {
        transform: translate3d(0%);
      }
      100% {
        transform: translate3d(100%);
      }
    }
  }
  span {
    color: #000;
    font-size: 12px;
    font-weight: 500;
  }
}

.places {
  position: absolute;
  z-index: 999;
  right: 10px;
  top: 8px;
}
.clearIcon {
  cursor: pointer;
  color: #b2b6c0;
  &:hover {
    color: #000;
  }
}
/deep/ .el-input__inner {
  height: 36px;
  border: 1px solid #b4bac8;
  color: #000c2e;
  font-family: OpenSans;
  padding: 4px 12px 0 ;
  font-size: 12px;
  font-weight: 600;
  &:hover {
    border: 1px solid #8993a9;
  }
  &:focus {
      border: 1px solid #4066d4 !important;
  }
}
.is-focus::after{
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  width: 100%;
  height: 36px;
  border: 2px solid #c6d1f2;
  border-radius: 6px;
}
.searchFont {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 99;
}
.search-disbled {
  border: none;
  button {
    width: 100%;
    height: 36px;
    border: 0;
    border: none;
    outline: 0;
    text-align: left;
    background: #fff;
    padding-left: 15px;
  }
  
}
.search-container {
  position: relative;
  label {
    z-index: 1200;
    position: absolute;
    font-size: 12px;
    color: #7f8596;
    top: -10px;
    margin-left: 15px;
    transform: translateY(20px);
    transition: all 200ms ease;
    font-weight: 500;
    height: 22px;
    line-height: 22px;
    margin-top: 6px;
  }
  input {
    width: 100%;
    height: 100%;
    outline: none;
    padding-top: 0 !important;
    border-radius: 4px;
    border: none;
    font-size: 12px;
    text-indent: 1em;
  }

  .search-autocomplete {
    width: 100%;
    height: 40px;
    border-radius: 4px;
    background-color: #ffffff;

    ::v-deep {
      .el-input__suffix {
        right: 13px;
        .search-icon {
          padding-left: 5px;
          display: flex;
          height: 100%;
          align-items: center;
          cursor: pointer;
          .icon-search {
            display: block;
            width: 24px;
            height: 24px;
          }
        }
      }
      .el-input__inner {
        padding-top: 0px;
        color: #001b42;
        font-size: 12px;
        font-weight: 500;

      }
      .el-input-group__append {
        padding: 0;
        background-color: #ffffff;
        .append-box {
          padding: 0 10px;
          border-left: 1px solid #dee5ef;
          display: flex;
          align-items: center;
          justify-content: center;
          .append-icon {
            display: inline-block;
            width: 24px;
            height: 24px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }
      }
      .search-autocomplete-popper {
        position: absolute !important;
        width: auto !important;
        left: 0 !important;
        right: 0 !important;
        border: none;
        // box-shadow: 0 4px 6px 0 rgba(70, 83, 106, 0.2);
        .el-autocomplete-suggestion__wrap {
          padding: 12px 0 !important;
          border-radius: 6px;
          box-shadow: 0 1px 5px 0 rgba(0, 5, 57, 0.2) !important;
          .el-autocomplete-suggestion__list {
            padding: 0 10px;
            li {
              padding: 0;
              background: #fff !important;
              &:hover {
                border-radius: 4px;
                background: #f4f5f9 !important;
              }
              .clear-history-container {
                padding: 0px 16px 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: initial;
                line-height: normal;
                background: #ffffff !important;
                .title {
                  font-family: HelveticaNeue, sans-serif;
                  font-size: 12px;
                  color: #99a4b3;
                }
                .clear-btn {
                  font-family: HelveticaNeue, sans-serif;
                  font-size: 12px;
                  color: #4066d4;
                  cursor: pointer;
                }
              }
              .search-result-wrapper {
                width: 100%;
                padding: 0 10px;
                .search-result-container {
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                  .search-result-icon {
                    margin-right: 8px;
                    flex-shrink: 0;
                    width: 20px;
                    height: 20px;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                  }
                  .address-icon {
                    background: url("~@/assets/img/search-list-icon/ic-list-address.svg")
                      no-repeat;
                  }
                  .poi-icon {
                    margin-right: 10px;
                    flex-shrink: 0;
                    font-size: 20px;
                  }
                  .search-result-content {
                    padding: 11px 0;
                    flex: 1;
                    overflow: hidden;
                    line-height: normal;
                    .title {
                      font-weight: 500;
                      font-size: 12px;
                      color: #001b42;
                      b {
                        font-family: HelveticaNeue-Medium, sans-serif;
                      }
                    }
                    .address {
                      margin-top: 4px;
                      font-family: HelveticaNeue, sans-serif;
                      font-size: 12px;
                      color: #7f8da0;
                    }
                  }
                }
              }
              &:nth-last-of-type(1) {
                .search-result-wrapper .search-result-container {
                  border: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .search-focus {
    transform: translateY(-8px);
    font-size: 12px;
    background: #fff;
    margin-left: 15px;
    color: #4066d4;
    font-weight: 500;
  }
  .search-value-focus {
    transform: translateY(-8px);
    font-size: 12px;
    background: #fff;
    margin-left: 15px;
    color: #7f8596;

    font-weight: 500;
  }
  .search-blur {
    font-size: 12px;
    transform: translateY(12px);
    color: #7f8596;
    font-weight: 500;
  }
  .connected {
    ::v-deep {
      .search-autocomplete-popper {
        margin-top: 4px !important;
        border: 0;
        // border-top: 1px solid #dee5ef;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        .popper__arrow {
          display: none;
        }
      }
    }
    &[aria-expanded="true"] {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
/deep/.overflow-management {
  b {
    color: #4066d4 !important;
  }
}
</style>
